import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  getCampaigns as getCampaignsApi,
  getCampaignsSpecial as getCampaignsSpecialApi,
  addNewCampaign as addNewCampaignApi,
  updateCampaign as updateCampaignApi,
  deleteCampaign as deleteCampaignApi,
  getTasksWithCounts as getTasksWithCountsApi,
  updateAnalyzeHistory as updateAnalyzeHistoryApi
} from "../../helpers/realbackend_helper";

export const getCampaigns = createAsyncThunk("campaign/getCampaigns", async (_, { rejectWithValue }) => {
  try {
    const response = await getCampaignsApi()
    return response;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getCampaignsSpecial = createAsyncThunk("campaign/getCampaignsSpecial", async (special, { rejectWithValue }) => {
  try {
    const response = await getCampaignsSpecialApi(special);
    return response;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const addNewCampaign = createAsyncThunk("campaign/addNewCampaign", async (campaign, { rejectWithValue }) => {
  try {
    const response = await addNewCampaignApi(campaign);
    toast.success("Судалгааны мэдээллийг амжилттай нэмлээ", { autoClose: 3000 });
    return response;
  } catch (error) {
    toast.error("Судалгааны мэдээллийг нэмэхэд алдаа гарлаа!", { autoClose: 3000 });
    return rejectWithValue(error);
  }
});

export const updateCampaign = createAsyncThunk("campaign/updateCampaign", async (campaign, { rejectWithValue }) => {
  try {
    const response = await updateCampaignApi(campaign);
    toast.success("Судалгааны мэдээллийг амжилттай засварлалаа", { autoClose: 3000 });
    return response;
  } catch (error) {
    toast.error("Судалгааны мэдээллийг засварлахад алдаа гарлаа!", { autoClose: 3000 });
    return rejectWithValue(error);
  }
});

export const deleteCampaign = createAsyncThunk("campaign/deleteCampaign", async (campaign, { rejectWithValue }) => {
  try {
    const response = await deleteCampaignApi(campaign);
    toast.success("Судалгааны мэдээллийг амжилттай устгалаа", { autoClose: 3000 });
    return { campaign, ...response };
  } catch (error) {
    toast.error("Судалгааны мэдээллийг устгахад алдаа гарлаа!", { autoClose: 3000 });
    return rejectWithValue(error);
  }
});

export const getCampaignsWithCounts = createAsyncThunk("campaign/getCampaignsWithCounts", async (_, { rejectWithValue }) => {
  try {
    const response = await getTasksWithCountsApi();
    return response;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const updateAnalyzeHistory = createAsyncThunk("campaign/updateAnalyzeHistory", async ({ id, period, data }, { rejectWithValue }) => {
  try {
    const response = await updateAnalyzeHistoryApi({ id, period, data });
    toast.success("Demographic мэдээллийг амжилттай хадгаллаа", { autoClose: 3000 });
    return response;
  } catch (error) {
    toast.error("Demographic мэдээллийг хадгалахад алдаа гарлаа!", { autoClose: 3000 });
    return rejectWithValue(error);
  }
});
